import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {JobType} from '../models/pos/jobType.model';
import {Job} from '../models/pos/job.model';
import {JobUpdateRequest} from '../models/pos/jobUpdate.request';
import {map} from 'rxjs/operators';
import {JobTransformRequest} from '../models/pos/jobTransform.request';

@Injectable({
  providedIn: 'root'
})
export class PosService {


  private POS_URL: string = environment.BASE_URL + 'job';
  private PUBLIC_POS_URL: string = environment.BASE_URL + 'public/invoice';

  constructor(private http: HttpClient) {
  }

  private static mapJobDate(job: Job): Job {
    job.dateIn = new Date(job.dateIn);

    if (job.dateOut) {
      job.dateOut = new Date(job.dateOut);
    }
    return job;
  }

  getJobs(type: JobType): Observable<Job[]> {
    const params = new HttpParams().set('type', type);
    return this.http.get<Job[]>(this.POS_URL, {params}).pipe(map(jobs => jobs.map(PosService.mapJobDate)));
  }

  getJob(id: string): Observable<Job> {
    return this.http.get<Job>(`${this.POS_URL}/${id}`).pipe(map(PosService.mapJobDate));
  }

  createJob(type: JobType): Observable<Job> {
    return this.http.post<Job>(this.POS_URL, {type}).pipe(map(PosService.mapJobDate));
  }

  lockJob(id: string): Observable<Job> {
    return this.http.post<Job>(`${this.POS_URL}/${id}/lock`, {}).pipe(map(PosService.mapJobDate));
  }

  unlockJob(id: string): Observable<Job> {
    return this.http.delete<Job>(`${this.POS_URL}/${id}/lock`).pipe(map(PosService.mapJobDate));
  }

  closeJob(id: string): Observable<Job> {
    return this.http.delete<Job>(`${this.POS_URL}/${id}`).pipe(map(PosService.mapJobDate));
    ;
  }

  reopenJob(id: string): Observable<Job> {
    return this.http.put<Job>(`${this.POS_URL}/${id}`, {}).pipe(map(PosService.mapJobDate));
    ;
  }

  updateJob(id: string, request: JobUpdateRequest): Observable<Job> {
    request.report = request.report?.replace(new RegExp('<br>', 'g'), '<br/>');
    return this.http.patch<Job>(`${this.POS_URL}/${id}`, request).pipe(map(PosService.mapJobDate));
  }

  transformJob(request: JobTransformRequest): Observable<Job> {
    return this.http.post<Job>(`${this.POS_URL}/transform`, request).pipe(map(PosService.mapJobDate));
  }

  getFullInvoice(organizationHandle: string, id: string): Observable<any> {
    return this.http.get<any>(`${this.PUBLIC_POS_URL}/${id}`, {headers: {organization: organizationHandle}}).pipe(map(PosService.mapJobDate));
  }
}
